import type { ProviderGoalAction, ProviderGoalSnapshot } from "@afar-research/contracts";

/** Admission is about explicit human intent, never an AFAR continuation scheduler. */
export function providerGoalActionError(
  snapshot: ProviderGoalSnapshot | null | undefined,
  input: ProviderGoalAction,
): string | null {
  if (input.action === "refresh" || input.action === "stop") return null;
  if (snapshot?.state !== "available") {
    if (input.action === "start" && input.objective?.trim()) return null;
    return "Refresh the native Goal before changing it.";
  }
  const goal = snapshot.goal;
  if (input.action === "start") {
    if (!input.objective?.trim()) return "Enter an objective.";
  }
  if ((input.action === "edit" || input.action === "resume") && goal === null)
    return "There is no Goal to change.";
  if (input.action === "resume" && goal !== null) {
    const budget = input.tokenBudget === undefined ? goal.tokenBudget : input.tokenBudget;
    if (budget != null && budget <= goal.tokensUsed)
      return "Raise the cumulative token budget before resuming.";
  }
  return null;
}

export function providerGoalRequestState(
  activities: ReadonlyArray<{
    readonly kind: string;
    readonly summary: string;
    readonly payload: unknown;
  }>,
) {
  const latest = activities.findLast((activity) => activity.kind.startsWith("provider-goal."));
  return {
    pending: latest?.kind === "provider-goal.requested",
    error: latest?.kind === "provider-goal.failed" ? latest.summary : null,
  };
}
